import Dashboard from '../Dashboard/Dashboard'

import './../styles/index.scss'

function App() {
  return <Dashboard />
}

export default App
